import { useFormikContext } from "formik";
import { useEffect } from "react";

type Props = {};
export const FillFormWithLocalStorage = (props: Props) => {
  const { setValues } = useFormikContext();

  const localStorageFormValues = localStorage.getItem("landingFormValues");
  const parsedLocalStorageFormValues =
    localStorageFormValues && JSON.parse(localStorageFormValues);

  useEffect(() => {
    parsedLocalStorageFormValues && setValues(parsedLocalStorageFormValues);
  }, [localStorageFormValues]);
  return null;
};
